'use client'

import { useEffect } from 'react'
import { useLang } from '@/context/LangContext'
import { registerWebMcpTools } from '@/lib/webmcp/registry'

export default function WebMcpProvider() {
  const lang = useLang()

  useEffect(() => {
    let cleanup: (() => void) | undefined
    let cancelled = false
    // Defer to idle so LCP/INP are unaffected; no-op on browsers without WebMCP.
    const w = window as unknown as {
      requestIdleCallback?: (cb: () => void) => number
      cancelIdleCallback?: (id: number) => void
    }
    const idle = (cb: () => void): number => {
      if (typeof w.requestIdleCallback === 'function') return w.requestIdleCallback(cb)
      return window.setTimeout(cb, 1500)
    }
    const id = idle(() => {
      registerWebMcpTools(lang)
        .then((fn) => {
          if (!cancelled) cleanup = fn
          else fn()
        })
        .catch(() => undefined)
    })
    return () => {
      cancelled = true
      const cw = window as unknown as { cancelIdleCallback?: (id: number) => void }
      if (typeof cw.cancelIdleCallback === 'function') {
        try {
          cw.cancelIdleCallback(id)
        } catch {
          // ignore
        }
      } else {
        clearTimeout(id)
      }
      cleanup?.()
    }
  }, [lang])

  return null
}
